import React from "react"
import styles from "./EmployerName.module.scss"
import { GradeType } from 'modules/spending/departments/models/employee-position'

export const formatGradeName = (gradeName: string, percent: number) => {
    const name = gradeName.toLowerCase().includes('ранг')
        ? gradeName
        : `Ранг ${gradeName}`

    return `${name}  -  ${percent}%`
}

export const EmployerName = ({ name, position, showTitle, style, grade }: EmployerNameProps) => (
    <div className="employer-name" title={showTitle ? name : ""} style={style}>
        <span className="employer-name-label">{name}</span>
        <div className={`employer-position ${styles.small}`}>{position}</div>
        {grade != null && <div className={`employer-position ${styles.small} ${styles.grade}`}>{formatGradeName(grade.gradeName, grade.percent)}</div>}
    </div>
)

interface EmployerNameProps {
    name: string
    position: string
    grade?: GradeType | null
    showTitle?: boolean
    style?: React.CSSProperties
}
